<template>
  <v-card>
    <v-card-title>{{ title }}</v-card-title>
    <v-card-text>
      <div v-for="(item, index) in ratings" :key="`rating-${index}`">
        <v-row dense>
            <v-col cols="12" md="6" align-self="center">
                {{ $t(item.text) }}
            </v-col>
            <v-col cols="12" md="6">
                <v-rating
                  length="5"
                  size="25"
                  :value="review[item.value] || 0"
                  background-color="orange lighten-3"
                  color="orange"
                  readonly
                />
            </v-col>
        </v-row>
        <v-divider v-if="index < ratings.length - 1" class="my-3"/>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'Review',
  props: {
    title: {
      type: String
    },
    review: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ratings: [
        {
          value: 'time_management',
          text: 'Time management'
        },
        {
          value: 'economic',
          text: 'Economic evaluation'
        },
        {
          value: 'technical',
          text: 'Technical evaluation'
        },
        {
          value: 'team_working',
          text: 'Team working'
        },
        {
          value: 'creativity',
          text: 'Creativity'
        }
      ]
    }
  }
}
</script>
